import { CloseOutlined } from "@ant-design/icons";
import { AddFilter, FilterItem } from "@/controls";
import { Button, Input, Form } from "antd";
import { useState, useEffect } from "react";
import { ticketStatuses } from "../../extensions/helper";
import { productVids, paymentsVids } from "../../extensions/helper";
import { dictsGetPaymentVids, dictsGetUsers } from "../../extensions/dicts"

const reestrFilterOptions = [
  { label: "Да", value: true },
  { label: "Нет", value: false },
];

const PaymentsFilter = ({ items = [], value, activePage, onClose }) => {
  const emptyFilter = { searchText: '' };
  const [tempFilter, setTempFilter] = useState(() => {
    try {
      const key = activePage === 'tickets' ? 'ticketsFilter' : 'paymentsFilter';
      const saved = localStorage.getItem(key);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch {}
    return emptyFilter;
  });

  useEffect(() => {
    if (value && Object.keys(value).length > 0) {
      setTempFilter(value);
    }
  }, [value]);
  const [addingFilter, setAddingFilter] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [paymentsVid, setPaymentsVid] = useState([]);

  const onSearchChange = (changed) => {
    setTempFilter(prev => ({ ...prev, searchText: changed.searchText }));
  };

  const filterOptions = activePage === "payments" ? [
    { type: "vid", label: "Вид", inputType: "multiselect", options: paymentsVids.filter(({ value }) => value !== 11 && value !== 12) },
    { type: "paymentVidId", label: "Вид продажи", inputType: "multiselect", options: productVids },
    { type: "paymentVids", label: "Вид оплаты", inputType: "multiselect", options: paymentsVid },
    { type: "userId", label: "Пользователь", inputType: "multiselect", options: userOptions },
    { type: "inReestr", label: "Платеж в реестре", inputType: "select", options: reestrFilterOptions },
  ] : [
    { type: "status", label: "Статус", inputType: "multiselect", options: ticketStatuses }
  ];

  const filterLabels = activePage === "payments" ? {
    vid: "Вид",
    paymentVidId: "Вид продажи",
    paymentVids: "Вид оплаты",
    userId: "Пользователь",
    inReestr: "Платеж в реестре",
  } : {
    status: "Статус",
  };

  const renderFilterItem = (key, data) => {
    const staticOption = filterOptions.find(f => f.type === key);
    const normalized = typeof data === 'object' && data !== null && !Array.isArray(data) && 'value' in data
      ? data
      : { value: data };
    const savedOptions = Array.isArray(normalized.options) ? normalized.options : [];
    const staticOptions = staticOption?.options || [];
    const combinedOptions = Array.from(new Map([...savedOptions, ...staticOptions].map(obj => [obj.value, obj])).values());
    
    return (
      <Form.Item key={key} label={filterLabels[key] || key} style={{ width: "100%" }}>
        <FilterItem key={key} type={staticOption?.inputType} value={normalized.value} options={combinedOptions}
          onChange={(val) => onFilterChange({ [key]: val })}
          onRemove={() => {
            const { [key]: _, ...rest } = tempFilter;
            setTempFilter(rest);
          }}
        />
      </Form.Item>
    );
  };

  const filters = Object.entries(tempFilter)
    .filter(([key, data]) => !["searchText", "dateBeg", "dateEnd"].includes(key))
    .filter(([key]) => filterOptions.some(f => f.type === key))
    .map(([type, data]) => {
      const normalized = typeof data === 'object' && data !== null && !Array.isArray(data) && 'value' in data
        ? data
        : { value: data };
      return { type, ...normalized };
    });

  const onFilterChange = (changedValues) => {
    setTempFilter(prev => {
      const next = { ...prev };
      Object.keys(changedValues).forEach(key => {
        if (prev[key] && typeof prev[key] === 'object' && 'value' in prev[key]) {
          next[key] = { ...prev[key], value: changedValues[key] };
        } else {
          next[key] = changedValues[key];
        }
      });
      return next;
    });
  };
  
  const filteredPaymentsVids = Array.from(
    new Map(
      paymentsVids
        .filter(({ value }) => value !== 11 && value !== 12)
        .map((item) => [item.value, item])
    ).values()
  );

  const getUniqueOptions = (field) => {
    const unique = Array.from(new Set(items.map(item => item[field]).filter(Boolean)));
    return unique.map(value => ({ label: value, value }));
  };

  useEffect(() => {
    dictsGetUsers(setUserOptions);
    dictsGetPaymentVids(setPaymentsVid)
  }, []);

  const handleAddTopFilter = (type) => {
    if (tempFilter[type]) return;
    const option = filterOptions.find(opt => opt.type === type);
    const inputType = option?.inputType;
  
    let initialValue = undefined;
    let options = undefined;

    if (activePage === "payments") {
      if (inputType === "select" && type === "inReestr") {
        options = reestrFilterOptions;
      }

      if (inputType === "multiselect") {
        switch (type) {
          case "vid":
            options = filteredPaymentsVids;
            break;
          case "paymentVidId":
            options = productVids;
            break;
          case "userId":
            options = userOptions;
            break;
          case "paymentVids":
            options = paymentsVid;
            break;
          default:
            options = getUniqueOptions(type);
        }
      }
    } else {
      if (inputType === "multiselect") {
      switch (type) {
        case "status":
          options = ticketStatuses;
          break;
        default:
          options = getUniqueOptions(type);
        }
      }
    }

    onFilterChange({ [type]: { value: initialValue, inputType, options } });
    setAddingFilter(false);
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="payments-mobile-filter-container">
          <Input placeholder="Введите наименование, ФИО, ID платежа/продажи/визита" allowClear className="search-str" value={tempFilter?.searchText} onChange={(e) => onSearchChange({ searchText: e.target.value })}/>
            {filters.length === 0 && !addingFilter && (
              <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
            )}
            {filters.map((f) => renderFilterItem(f.type, f))}
            {filters.length < filterOptions.length && (
              addingFilter ? (
                <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
              ) : (
                filters.length !== 0 && (
                  <Button onClick={() => setAddingFilter(true)} type="dashed" className="filter-add-button">+</Button>
                )
              )
            )}
            <Button onClick={() => onClose(tempFilter)}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsFilter;
